module.exports = __webpack_public_path__ + "static/img/RAZ-G1_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAZ-G1_1.png
// module id = L4rO
// module chunks = 0